/**
 * Ryan O'Dowd
 * 2021-06-28
 * © Copyright 2021 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Text as PaperText,
} from 'react-native-paper';
import {
  Platform,
} from 'react-native';
import React from 'react';
import getStyles from './styles';
import useStyles from '@hooks/useStyles'; // @NOTE: importing directly to avoid circular import

const Text = (props: TextProps & React.ComponentProps<typeof PaperText>) => {
  const styles = useStyles(getStyles);

  const styleValue = [
    styles.container,
    props.isLink && styles.link,
    ...(Array.isArray(props.style) ? props.style : [props.style]),
  ];
  const onPressValue = !props.onPress ? undefined : () => props.onPress();

  if (Platform.OS === 'web' && props.href) {
    return (
      // @TODO: chatgpt has some ideas to use text instead of a tag but still do hover-and-discover...may be worth switching
      // @ts-ignore // @TODO: yeet
      <a
        {...props}
        style={Object.assign({}, ...styleValue)}
        href={props.href}// @TODO: this shouldn't cause a page refresh...useNavigation?
      >
        {props.children}
      </a>
    );
  }

  return (
    <PaperText
      allowFontScaling={false}
      {...props}
      style={styleValue}
      onPress={onPressValue}
    >
      {props.children}
    </PaperText>
  );
};

class TextProps {
  isLink?: boolean;
  onPress?: () => void; // @TODO: native or non-href only
  href?: string; // @TODO: only for web
};

Text.displayName = 'Text';
export default Text;
